import React, { memo, useState, useEffect, useMemo } from "react";

import {
  Container,
  ItemsScrollArea,
  ContainerItem,
  PaginationFooter,
} from "./styles";

import CrudLoader from "loader/CrudLoader";
import Pagination from "components/Pagination";

const DEFAULT_PAGE_SIZE = 20;

// ListOf: lista paginada de items administrables.
// El form de edición y la confirmación de eliminación viven en Modales
// (manejados por AdminPage), no acá. Este componente solo renderiza las cards
// + paginador.
const ListOf = memo(
  ({
    loading,
    items,
    cardItem,
    itemSelectedId,
    itemDeletedId,
    pageSize = DEFAULT_PAGE_SIZE,
  }) => {
    const [currentPage, setCurrentPage] = useState(1);

    // Reseteo a página 1 cuando cambia el conjunto de items (filtros, búsqueda).
    const itemsKey = useMemo(
      () =>
        items.length === 0
          ? "empty"
          : `${items.length}:${items[0]?.id}:${items[items.length - 1]?.id}`,
      [items]
    );

    useEffect(() => {
      setCurrentPage(1);
    }, [itemsKey]);

    const totalItems = items.length;
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;
    const paginatedItems = useMemo(
      () => items.slice(start, end),
      [items, start, end]
    );

    return (
      <Container>
        {loading ? (
          <ItemsScrollArea>
            <CrudLoader counter={2} />
          </ItemsScrollArea>
        ) : (
          <>
            <ItemsScrollArea>
              {paginatedItems.map((item) => (
                <ContainerItem key={item.id}>
                  {cardItem(
                    item,
                    item.id === itemSelectedId || item.id === itemDeletedId
                  )}
                </ContainerItem>
              ))}
            </ItemsScrollArea>

            <PaginationFooter>
              <Pagination
                currentPage={currentPage}
                totalItems={totalItems}
                pageSize={pageSize}
                onPageChange={setCurrentPage}
              />
            </PaginationFooter>
          </>
        )}
      </Container>
    );
  }
);

export default ListOf;
